import config from '@/services/Config';
import axios from 'axios';
import RequestConfig from '@/services/RequestConfig';

let restModel = 'auth';
let baseUrl = config.apiBaseUrl;

export default {
  // Custom endpoints
  async loginWeb(email, password) {
    try {
      await axios.post(baseUrl + '/' + restModel + '/web/login', { email, password }, RequestConfig);
      return true;
    }
    catch(err) {
      if(err.response && err.response.status === 401) {
        return false;
      }

      return null;
    }
  },
  
  async checkWeb() {
    try {
      await axios.get(baseUrl + '/' + restModel + '/web/check', RequestConfig);
      return true;
    }
    catch(err) {
      return false;
    }
  },
  
  async logoutWeb() {
    try {
      await axios.post(baseUrl + '/' + restModel + '/web/logout', null, RequestConfig);
      return true;
    }
    catch(err) {
      return false;
    }
  },
  
  async checkActivationCode(code) {
    try {
      await axios.post(baseUrl + '/' + restModel + '/web/checkActivationCode', {code}, RequestConfig);
      return true;
    }
    catch(err) {
      return false;
    }
  },
  
  async activate(code, password) {
    try {
      await axios.post(baseUrl + '/' + restModel + '/web/activate', { code, password }, RequestConfig);
      return true;
    }
    catch(err) {
      return false;
    }
  },

  async sendPasswordReset(emailAddress) {
    try {
      await axios.post(baseUrl + '/' + restModel + '/web/send-password-reset', { email: emailAddress }, RequestConfig);
      return true;
    }
    catch(err) {
      if(err.response.status == 404) {
        return 404;
      }

      return false;
    }
  },

  async checkPasswordResetCode(code) {
    try {
      await axios.post(baseUrl + '/' + restModel + '/web/checkPasswordResetCode', {code}, RequestConfig);
      return true;
    }
    catch(err) {
      return false;
    }
  },

  async resetPassword(code, password) {
    try {
      await axios.post(baseUrl + '/' + restModel + '/web/reset-password', { code, password }, RequestConfig);
      return true;
    }
    catch(err) {
      return false;
    }
  },
}
